import {Component} from '@angular/core';
import {NotificationService} from '../../../services/notification.service';
import {triggerChildAnimation} from '../../../animations';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'lv-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    animations: [
        trigger('slideIn', [
            state('*', style({
                transform: 'translateX(0)',
            })),
            state('void', style({
                transform: 'translateX(100%)',
            })),
            transition('void => *', animate('800ms ease-in')),
        ]),
        trigger('slideOut', [
            state('*', style({
                transform: 'translateX(0)',
            })),
            state('void', style({
                transform: 'translateX(100%)',
            })),
            transition('* => void', animate('800ms ease-out')),
        ]),
        triggerChildAnimation,
    ],
    standalone: false
})
export class NotificationComponent {
  constructor(public notificationService: NotificationService) {
  }
}
